const PERMISSION_KEY= "core:api_key_permission";
const PAGE_URL = {
    API_KEY_PERMISSION_PAGE: "/admin/core/api-key-permission"
}

export {PERMISSION_KEY, PAGE_URL}

